import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    nexaConfig: {},
    loadingMessage: "",
    isConfigLoaded: false,
    isShowLoadingMessage: false,

    errorTitle: "",
    errorMessage: "",
    isShowError: false,

    isShowOverlay: false,
    overlayTitle: "",
    overlayMessage: "",
    overlaySolveMethod: null,
    overlaySolveButtonLabel: "",

    existingTicket: false,
  },
  mutations: {
    // Manage config:
    initConfig(state, payload) {
      if (process.env.VUE_APP_ISDEBUGGING)
        console.log("initConfig: " + JSON.stringify(payload));
      state.nexaConfig = Object.assign({}, payload);
    },
    appendConfig(state, payload) {
      if (process.env.VUE_APP_ISDEBUGGING) console.log("appendConfig run.");
      state.nexaConfig = Object.assign({}, state.nexaConfig, payload);
    },
    setConfigLoaded(state, payload) {
      state.isConfigLoaded = payload;
    },
    // Loading:
    setLoadingMessage(state, payload) {
      state.loadingMessage = payload;
    },
    setShowLoadingMessage(state, payload) {
      state.isShowLoadingMessage = payload;
    },
    setErrorMessage(state, { title, message }) {
      state.isShowError = true;
      state.errorTitle = title;
      state.errorMessage = message;
    },
    setIsShowError(state, payload) {
      state.isShowError = payload;
    },
    showOverlay(
      state,
      { overlayTitle, overlayMessage, solveMethod, buttonLabel }
    ) {
      state.isShowOverlay = true;
      state.overlayTitle = overlayTitle ? overlayTitle : "";
      state.overlayMessage = overlayMessage ? overlayMessage : "";
      state.overlaySolveMethod = solveMethod;
      state.overlaySolveButtonLabel = buttonLabel;
    },
    hideOverlay(state) {
      state.isShowOverlay = false;
    },
    existingTicket(state, payload) {
      state.existingTicket = payload;
    },
  },
  actions: {},
  modules: {},
  getters: {
    isConfigLoaded: (state) => {
      return state.isConfigLoaded;
    },
    isShowLoadingMessage: (state) => {
      return state.isShowLoadingMessage;
    },
    getConfigItem: (state) => (itemKey, isBoolean = false) => {
      if (state.nexaConfig == null) {
        return "";
      }

      if (state.nexaConfig[itemKey] == null) {
        return "";
      }

      if (isBoolean) {
        return state.nexaConfig[itemKey].toLowerCase() === "true";
      } else {
        return state.nexaConfig[itemKey];
      }
    },
    getConfigItemNestedObjectValue: (state) => (itemKey, objKey) => {
      // state expects json objects with double quotes: "BOOKING_URL":"{ \"title\": \"Make an appointment\", \"url\": \"http://10.1.1.165/MonashOASIS/Home/AppointmentMenu\" }"
      if (state.nexaConfig == null) {
        return "";
      }

      if (state.nexaConfig[itemKey] == null) {
        return "";
      }

      try {
        const item = JSON.parse(state.nexaConfig[itemKey]);
        if (item == "") {
          return "";
        }

        if (item[objKey] == null) {
          return "";
        }

        return item[objKey];
      } catch (error) {
        // TODO: Error handling
        console.log(
          "itemKey = " +
            itemKey +
            ". Error in getConfigItemNestedObjectValue:" +
            error
        );
        return "";
      }
    },
    isShowError: (state) => {
      return state.isShowError;
    },
    errorTitle: (state) => {
      return state.errorTitle;
    },
    errorMessage: (state) => {
      return state.errorMessage;
    },
    isShowOverlay: (state) => {
      return state.isShowOverlay;
    },
    overlayMessage: (state) => {
      return state.overlayMessage;
    },
    overlayTitle: (state) => {
      return state.overlayTitle;
    },
    overlayButtonLabel: (state) => {
      return state.overlaySolveButtonLabel;
    },
    existingTicket: (state) => {
      return state.existingTicket;
    },
  },
});
